<template>
   <div class="box">
      <div class="box__header">
         <div class="box__icon" v-if="icon">
            <template v-if="!animated">
               <div class="box__icon-holder">
                  <component
                     v-bind:is="iconSvgComponent()"
                  />
               </div>
            </template>
            <template v-else>
               <VIconResultMessage
                  type='success'
                  iconSvgName='PixIcon'
                  v-if="success"
               />
               <VIconResultMessage
                  type='error'
                  iconSvgName='PixIcon'
                  v-else
               />
            </template>
         </div>
         <h2 :class="`box__title ${success && `box__title--success`}`" v-if="title">{{ title }}</h2>
         <span class="box__description" v-if="description">{{ description }}</span>
      </div>
      <div class="box__content">
         <slot />
      </div>
   </div>
</template>

<script>
import VIconResultMessage from '@/components/commons/VIconResultMessage';

export default {
  name: 'BoxContent',
  components: {
    VIconResultMessage,
  },
  props: {
    title: String,
    description: String,
    icon: String,
    animated: Boolean,
    success: Boolean,
  },
  methods: {
    iconSvgComponent() {
      return `${this.icon}Svg`;
    },
  }
};
</script>

<style lang="scss" scoped>
   .box {
      background: #FFFFFF;
      box-shadow: 0px 12px 12px rgba(22, 22, 22, 0.04), 0px 24px 56px rgba(22, 22, 22, 0.08);
      border-radius: 4px;
      color: #343A40;
      padding: 16px;

      &__title {
         font-weight: 700;
         font-size: 20px;
         margin-bottom: 4px;

         &--success {
            color: #2DA853;
            font-weight: 700;
            font-size: 20px;
            line-height: 120%;
         }
      }

      &__description {
         font-weight: 300;
      }

      &__icon-holder {
         width: 72px;
         height: 72px;
         border-radius: 100%;
         background: var(--color-slider-circle);
         display: flex;
         align-items: center;
         justify-content: center;
         margin: 16px auto;
      }
   }
</style>
